import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

export default function CourseEditorSkeleton(): ReactNode {
  return (
    <div className="flex w-full flex-col gap-5 overflow-hidden bg-bg-primary">
      <Skeleton className="h-8 w-64 rounded-xs" />
      {Array.from({ length: 7 }).map((_, i) => (
        <div key={i} className="grid grid-cols-[2.5rem_1fr] grid-rows-[2rem_1fr] gap-2">
          <Skeleton className="col-span-2 h-8 w-48 rounded-xs" />
          <Skeleton className="size-8 rounded-full" />
          <Skeleton className="h-8 w-48 rounded-xs" />
        </div>
      ))}
      <Skeleton className="h-10 w-64 self-center rounded-xs" />
    </div>
  )
}
